import * as views from "../views";
import { i18nFormat } from "@/i18n.js";

export default [
  // {
  //   path: "account",
  //   component: RouterView,
  //   children: [
  //     {
  //       path: "faqs",
  //       name: "FAQs",
  //       component: views.FAQs
  //     }
  //   ]
  // },
  {
    path: "faqs",
    name: "FAQs",
    component: views.FAQs,
    meta: {
      headerVisible: true,
      headerTitle: i18nFormat("t", "pricing.faq"),
      headerDomain: null,
      allowAutoSidebar: true
    }
  }
];
